import { useRedux } from "hooks";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { createSelector } from "reselect";
import WorkplaceHead from "./WorkplaceHead";
import WorkplaceInput from "./WorkplaceInput";
import AppSimpleBar from "components/AppSimpleBar";
import WorkplaceQuill from "components/WorkplaceQuill";
import { LogDb, Utils } from "helpers/utils";
import Loader from "components/Loader";
import { TaskStatus, WpConver, WpEmoji, WpPostType, WpSliceData, WpStatus, PostCommands } from "../../../redux/workplace/wpTypes";
import { togglePostEmoji, setSnooze, setActivePostId2, setPostIdForInstanceAction } from "../../../redux/workplace/wpActions";
import classnames from "classnames";
import UserAvatar from "components/UserAvatar";
import { updateReadApi } from "../../../api/wpapi";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";


import { Const } from "const";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import LoadingIconWithText from "components/LoadingIconWithText";
import WorkplaceCollectionModal from "./WorkplaceCollectionModal";
import { useLocation, useNavigate } from "react-router-dom";
import { DbUtils } from "helpers/dbUtils";
import { WpModes } from "../../../constants";
import WorkplaceHeadTask from "./WorkplaceHeadTask";
import TaskFormField from "./TaskFormField";
import PostCommand from "./PostCommand";
import WorkplaceContent from "./WorkplaceContent";
import { changelayoutMode } from "../../../redux/actions";

interface WorkplacePostInstancePreviewProps {

}
const WorkplacePostInstancePreview = ({ }: WorkplacePostInstancePreviewProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (state: any) => state.Layout,
    (wp: WpSliceData, p2, layout) => ({
      curUserId: p2.userId,
      displayName2: p2.displayName2,
      layoutMode: layout.layoutMode,
      activePostId: wp.activePostInfo.postId,
      wpMode: wp.activePostInfo.wpMode,
      postIdInstant: wp.postIdInstant,
    })
  );

  const location = useLocation();
  const { layoutMode, curUserId, activePostId, /*wpMode,*/ displayName2, postIdInstant } = useAppSelector(storeData);

  const [postId2Err, setPostId2Err] = useState<string | null>(null);
  const [wpModeCheck, setWpModeCheck] = useState<WpModes | null>(null);

  useEffect(() => {
    dispatch(changelayoutMode(layoutMode));
  }, [dispatch, layoutMode]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const postid = queryParams.get('pid');
    if (postid) {
      dispatch(setPostIdForInstanceAction(postid));
    }
  }, [location]);

  useEffect(() => {
    console.log('postIdInstant = ' + postIdInstant);
    // if (postIdInstant) {
    const postId = postIdInstant?.split('|')[0];
    const api = new APIClient;
    api.fnPostForm(urls.WP_LOAD_POST_WP_MODE, { postId: postId })
      .then(rs => {
        console.log('WP_LOAD_POST_WP_MODE:', rs);
        const wpModeRs = rs?.wpMode;
        if (wpModeRs == WpModes.Task || wpModeRs == WpModes.Workplace) {
          console.log('set wpmodeCheck to ' + wpModeRs);
          setWpModeCheck(wpModeRs as WpModes);
          console.log('set active post to ' + postId);
          dispatch(setActivePostId2(wpModeRs, postId!, null, null, null, null, null));
        } else {
          setPostId2Err("Invalid WpMode of given post");
        }
      })
      .catch(ex => {
        setPostId2Err(Utils.GetMessageFromExecption(ex));
      });
    // }
  }, [postIdInstant]);

  const incompleted = curUserId == null || activePostId == null || wpModeCheck == null;

  return (
    <div className="post-instance-container " style={{ height: "calc(100vh)" }}>
      {incompleted ? (
        <div className="d-flex flex-column justify-content-center align-items-center gap-2" style={{ height: "100%" }}>
          {!curUserId ? (<div className="btn2 btn2-warning ">❌ No User</div>) : (<div className="btn2 btn2-success">✅ {displayName2}</div>)}
          {!activePostId && (<div className="btn2 btn2-warning">❌ No Post/Task</div>)}
          {(!activePostId && postId2Err) && (<div className="btn2 btn2-warning">❌ {postId2Err}</div>)}
          {/* {incompleted && (<>Incompleted</>)}
          <pre>
            {JSON.stringify({ curUserId, activePostId, wpModeCheck, postIdInstant }, null, 2)}
          </pre> */}
        </div>
      ) : (
        <div style={{overflow:"hidden" }}>
          <WorkplaceContent wpMode={wpModeCheck} instantMode={true} />
        </div>
      )}
    </div>
  );
};

export default WorkplacePostInstancePreview;
